import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import AccountCircle from '@mui/icons-material/AccountCircle';
import { Drawer, Divider, Theme } from '@mui/material';
import AppInfos from '../common/AppInfos';

import LangButton from '../common/LangButton';
import MenuSelect from './MenuSelect';

const useStyles = makeStyles()((theme: Theme) => ({
  drawerPaper: {
    position: 'relative',
    background: theme.palette.grey[50],
    display: 'flex',
  },

  logo: {
    height: '50px',
    margin: theme.spacing(1),
  },
}));

interface UserData {
  familyName: string;
  givenName: string;
}

// TODO import Language from types
interface Language {
  country: string;
  id: number;
  locale: string;
  name: string;
  shortName: string;
}

interface RootState {
  auth: {
    userData: UserData;
  };
  app: {
    currentLanguage: Language;
  };
}

const MainMenu = () => {
  const theme: Theme = useTheme();
  const { classes } = useStyles();
  const { t, i18n } = useTranslation();

  const userData = useSelector((state: RootState) => state.auth.userData);
  const currentLanguage = useSelector((state: RootState) => state.app.currentLanguage);

  const dispatch = useDispatch();
  const changeLanguage = lang => {
    sessionStorage.setItem('locale', lang.locale);
    i18n.changeLanguage(lang.locale);
    dispatch({ type: 'UPDATE_LANGUAGE', value: lang });
  };

  return (
    <Drawer variant="permanent" classes={{ paper: classes.drawerPaper }}>
      <div>
        <img src="/resources/img/logo.png" className={classes.logo} alt="logo" />
      </div>
      <div style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
        <MenuSelect />
        <Divider />
      </div>
      <AppInfos />
      <div
        style={{
          display: 'flex',
          maxWidth: '100%',
          color: 'primary.main',
          padding: '4px 0px 4px 8px',
          justifyContent: 'center',
          outline: '1px solid #bdbdbd',
          overflow: 'hidden',
          wordBreak: 'break-word',
        }}
      >
        <div
          style={{
            color: theme.palette.primary.main,
            justifyContent: 'center',
            flexDirection: 'column',
            display: 'flex',
          }}
        >
          <AccountCircle />
        </div>
        <div
          style={{
            padding: '0 4px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textOverflow: 'ellipsis',
          }}
        >
          {`${userData.familyName} ${userData.givenName}`}
        </div>
        <div
          style={{
            flex: 1,
            textAlign: 'right',
          }}
        >
          <LangButton
            title={t('smartmessaging.tooltip.mainLangButton')}
            currentLang={currentLanguage}
            selectLang={changeLanguage}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default MainMenu;
